import service  from "@/utils/http";


//适用场景：按名称查询协议
export function agreementApi(data) {
  return service({
    url: `/Agreement/agreement_info`,
    method: "post",
    data:data
  });
}



//协议
export function agreementListApi(data) {
  return service({
    url: `/index/agreement`,
    method: "post",
    data:data
  });
}


//公告列表
export function getNoticeListApi(data) {
  return service({
    url: `/index/getNoticeList`,
    method: "post",
    data:data
  });
}

//公告详情
export function getNoticeInfoApi(data) {
  return service({
    url: `/index/getNoticeInfo`,
    method: "post",
    data:data
  });
}


//公告详情
export function corporateSettingApi(data) {
  return service({
    url: `/Index/corporate_setting`,
    method: "post",
    data:data
  });
}